import {RuntimeEnvironment} from "./RuntimeEnvironment";

export interface RuntimeEvent<M, E> {
  current: RuntimeEnvironment<M, E>;
  previous: RuntimeEnvironment<M, E>;
}

/**
 * Checks if the runtime has changed between the previous and current state.
 *
 * @param event The runtime event containing current and previous states
 * @returns true if the runtime has changed, false otherwise
 */
export function hasRuntimeChanged<M, E>(event: RuntimeEvent<M, E>): boolean {
  return event.current.runtime.id !== event.previous.runtime.id;
}

/**
 * Checks if the environment has changed between the previous and current state.
 * Uses reference equality to determine if the environment object has changed.
 *
 * @param event The runtime event containing current and previous states
 * @returns true if the environment reference has changed, false otherwise
 */
export function hasEnvironmentChanged<M, E>(event: RuntimeEvent<M, E>): boolean {
  return event.current.environment !== event.previous.environment;
}

